export default {
  Incorrect: 0, // không phù hợp
  Correct: 1, // phù hợp
  Irrelevant: 2, // không xác định
};
